// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { shimmerTestnet as _shimmerTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the shimmerTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1073
 * Chain Name: Shimmer Testnet
 * Default Block Explorer: https://explorer.evm.testnet.shimmer.network
 * Default RPC URL: https://json-rpc.evm.testnet.shimmer.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { shimmerTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: shimmerTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const shimmerTestnet = createCommon({
	..._shimmerTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
